import React, { useEffect } from 'react'
import Dialog, { DialogProps } from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import CircularProgress from '@mui/material/CircularProgress'
import CssBaseline from '@mui/material/CssBaseline'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { Root } from 'react-dom/client'
import { modalConfig } from './modal-theme'

export interface LoadingModalProps {
   container?: HTMLElement
   root?: Root
   title?: string
   visible?: boolean
   onClickAway?: () => void
}

export const LoadingModal = (props: LoadingModalProps) => {
   const { visible, container, title, root } = props

   useEffect(() => {
      return () => {
         if (!!container && !visible) {
            document.body.removeChild(container)
         }
      }
   })

   useEffect(() => {
      if (!!root && !visible) {
         setTimeout(() => root.unmount())
      }
   }, [visible, root])

   const handleClose: DialogProps["onClose"] = (event, reason) => {
      if (reason && reason === "backdropClick" && props.onClickAway) {
         props.onClickAway()
      }
   }

   const modal = (
      <Dialog
         open={visible || false}
         onClose={handleClose}
         aria-labelledby="alert-dialog-title"
         aria-describedby="alert-dialog-description">
         <DialogTitle color='primary' id="alert-dialog-title">{title}</DialogTitle>
         <DialogContent id="alert-dialog-description">
            <div
               style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: '150px',
                  minHeight: '70px',
               }}>
               <CircularProgress color="primary" />
            </div>
         </DialogContent>
      </Dialog>
   )

   if (container) {
      return (
         <StyledEngineProvider injectFirst>
            <ThemeProvider theme={modalConfig.theme}>
               <CssBaseline />
               {modal}
            </ThemeProvider>
         </StyledEngineProvider>
      )
   } else {
      return modal
   }
}
